import { startCase } from 'lodash'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { BsCheckCircle, BsEmojiLaughing, BsFacebook, BsWhatsapp } from 'react-icons/bs'
import { RxCrossCircled } from 'react-icons/rx'
import classNames from 'classnames'
import apiPath from 'utils/apiPath'
import { apiPut } from 'utils/apiFetch'
import useToastContext from 'hooks/useToastContext'
import helper from 'utils/helpers'
import DesView from "./descriptionViewModal";

const Verification = ({ item, getUserDetails }) => {
  const [data, setData] = useState(item)
  const { t } = useTranslation()
  const notification = useToastContext()
  const [viewDesShowModal, setViewDesShowModal] = useState(false)
  const [description, setDescription] = useState('')

  const handleRequest = async(status) => {
    try {
      const path = apiPath.verifyUser + '/' + item._id
      const result = await apiPut(path, { verificationStatus: status })
      if (result.data.success) {
        // getAllUser()
        // setEditShowModal(false)
        setData(result.data?.results)
        getUserDetails(item._id)
        notification.success(result?.data.message)
      } else {
        notification.error(result?.data.message)
      }
    } catch (error) {
      console.log('error in get all users list==>>>>', error)
      notification.error(error.message)
    }
  }
  const handleFieldVisitRequest = async(response) => {
    try {
      const path = apiPath.fieldVisitRequestResponse + '/' + item._id
      const result = await apiPut(path, { fieldVisitResponse: response })
      if (result.data.success) {
        // getAllUser()
        // setEditShowModal(false)
        setData(result.data?.results)
        getUserDetails(item._id)
        notification.success(result?.data.message)
      } else {
        notification.error(result?.data.message)
      }
    } catch (error) {
      console.log('error in get all users list==>>>>', error)
      notification.error(error.message)
    }
  }
 

  const handleDescriptionView = (item) => {
    setDescription(item)
    setViewDesShowModal(true)
  }


  return (
    <div>
    <div>{t('O_STATUS')}: {startCase(data?.verificationStatus)}</div>
    { data?.verificationSteps && <>
      <div className='py-5'>
      <div className=''><h3 className='font-bold mb-2 text-lg'>{t('RESPONSE_STEP_1')}</h3></div>
      <div className='flex flex-wrap columns-3 gap-10 2xl:gap-20'>
      {data?.verificationSteps?.questions?.length > 0 && data?.verificationSteps?.questions?.map((data, index) => {
        return <div className='' key={index}>
          <h4 className='font-medium mb-2'>{data?.question}</h4>
          <div className='flex columns-4 gap-3'>
                            <span className={classNames('border flex items-center justify-center text-lg rounded-md min-w-[40px] h-[40px] px-2  ',{'bg-yellow-100': data?.optionA === data?.selectedOption })}
                            
                            >
                                         {/* <span className='text-black cursor-pointer' onClick={()=> handleDescriptionView("data?.answer")}> {t('O_READ_MORE')}</span> */}

                           {(data?.answer)?.slice(0,50)} {data?.answer?.length > 50 && <span className='text-black cursor-pointer m-2' onClick={()=> handleDescriptionView(data?.answer)}> {  t('O_READ_MORE')}</span>}

                              </span>

              {/* <span className={classNames('border flex items-center justify-center text-lg rounded-md min-w-[40px] h-[40px] px-2  ',{'bg-yellow-100': data?.optionA === data?.selectedOption })}>{data?.optionA}</span>
              <span className={classNames('border flex items-center justify-center text-lg rounded-md min-w-[40px] h-[40px] px-2  ',{'bg-yellow-100': data?.optionB === data?.selectedOption })}>{data?.optionB}</span>
              <span className={classNames('border flex items-center justify-center text-lg rounded-md min-w-[40px] h-[40px] px-2  ',{'bg-yellow-100': data?.optionC === data?.selectedOption })}>{data?.optionC}</span>
              <span className={classNames('border flex items-center justify-center text-lg rounded-md min-w-[40px] h-[40px] px-2  ',{'bg-yellow-100': data?.optionD === data?.selectedOption })}>{data?.optionD}</span> */}
          </div>
      </div>
      })}
      </div>
    </div>


    <div className='py-5'>
      <div className=''><h3 className='font-bold mb-3 text-lg'>{t('RESPONSE_STEP_2')}</h3></div>
      <div className='flex columns-3 gap-20'>
      {/* <div className='w-[18%]'>
        <div className='flex items-center'>
          <span className='mr-2 text-2xl'><BsWhatsapp /></span>
            {t('O_WHATSAPP')}
           </div>
           {data?.verificationSteps?.socialConnects?.whatsapp ? <span className='block mt-3 text-green-500'>{t('O_CONNECTED')}</span> : <span className='block mt-3 text-red-500'>{t('O_PENDING')}</span>}
      </div> */}

      <div className='w-[18%]'>
      <div className='flex items-center'>
          <span className='mr-2 text-2xl'><BsFacebook /></span>
            {t('O_FACEBOOK')}
           </div>
           {data?.verificationSteps?.socialConnects?.facebook ? <span className='block mt-3 text-green-500'>{t('O_CONNECTED')}</span> : <span className='block mt-3 text-red-500'>{t('O_PENDING')}</span>}
      </div>

      {/* <div className='w-[18%]'>
      <div className='flex items-center'>
          <span className='mr-2 text-2xl'><BsEmojiLaughing /></span>
            {t('O_IMO')}
           </div>
           {data?.verificationSteps?.socialConnects?.IMO ? <span className='block mt-3 text-green-500'>{t('O_CONNECTED')}</span> : <span className='block mt-3 text-red-500'>{t('O_PENDING')}</span>}
      </div>  */}
      
      </div>  
    </div>


    <div className='py-5'>
      <div className=''><h3 className='font-bold mb-5 text-lg'>{t('REQUEST_FOR_FIELD_VISIT')}</h3></div>
       <div className='flex items-center'>
        <span className='block'>{data?.verificationSteps?.fieldVisitRequest ? t('O_YES') : t('O_NO')}</span>
        { data?.verificationSteps?.fieldVisitRequest && data?.verificationSteps?.responseOfVisitRequest === 'pending' &&
          <>
            <span className=' ml-5 text-[26px] cursor-pointer' title={t('O_ACCEPT')} onClick={e =>helper.alertFunction(`${t('ARE_YOU_SURE_TO_ACCEPT_FIELD_VISIT_REQUEST')}`,'accepted',handleFieldVisitRequest)}><BsCheckCircle/></span>
            <span className='text-[30px] ml-5 cursor-pointer' title={t('O_REJECT')} onClick={e =>helper.alertFunction(`${t('ARE_YOU_SURE_TO_REJECT_FIELD_VISIT_REQUEST')}`,'rejected',handleFieldVisitRequest)}><RxCrossCircled/></span>
          </>
        }
        {
          data?.verificationSteps?.fieldVisitRequest && data?.verificationSteps?.responseOfVisitRequest === 'accepted' &&
          <span> &nbsp; ({t('O_ACCEPTED')})</span>
        }
        {
          data?.verificationSteps?.fieldVisitRequest && data?.verificationSteps?.responseOfVisitRequest === 'rejected' &&
          <span> &nbsp; ({t('O_REJECTED')})</span>
        }
       </div>
    </div>
    <div className='py-5'>
    {data?.verificationStatus === 'pending' && 
    <>
      <button disabled={data?.verificationSteps?.fieldVisitRequest && data?.verificationSteps?.responseOfVisitRequest === 'pending'} className={classNames('btn mt-5 inline-block bg-green-500 py-2 px-4 rounded-md mr-3', {'cursor-pointer': data?.verificationSteps?.fieldVisitRequest && !data?.verificationSteps?.responseOfVisitRequest == 'pending', 'bg-[#cccccc]': data?.verificationSteps?.fieldVisitRequest && data?.verificationSteps?.responseOfVisitRequest === 'pending' })} onClick={e =>helper.alertFunction(`${t('ARE_YOU_SURE_TO_CHANGE_STATUS_ACCEPT')}`,'accepted',handleRequest)}>{t('O_ACCEPT')}</button>
          
      <button disabled={data?.verificationSteps?.fieldVisitRequest && data?.verificationSteps?.responseOfVisitRequest === 'pending'}  className={classNames('btn mt-5 inline-block bg-red-500 py-2 px-4 rounded-md', {'cursor-pointer': data?.verificationSteps?.fieldVisitRequest && !data?.verificationSteps?.responseOfVisitRequest == 'pending', 'bg-[#cccccc]': data?.verificationSteps?.fieldVisitRequest && data?.verificationSteps?.responseOfVisitRequest === 'pending' })} onClick={e =>helper.alertFunction(`${t('ARE_YOU_SURE_TO_CHANGE_STATUS_REJECT')}`,'rejected',handleRequest)}>{t('O_REJECT')}</button>
    </>}
    </div>
    </>}

    {viewDesShowModal ? (
        <DesView
          setViewDesShowModal={setViewDesShowModal}
          description={description}
        />
      ) : null}

    </div>
  )
}

export default Verification